/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { Picture } from "./Picture";
import { SocialMediaSettings } from "./SocialMediaSettings";

export interface Settings {
    address: string;
    facebookLink: string;
    mainEmail: string;
    orderEmail: string;
    phone: string;
    siteLink: string;
    siteName: string;
    twitterLink: string;
    instagramLink: string;
    vkLink: string;
    youtubeLink: string;
    conditionalBalance: boolean;
    telegramLink?: string;
    socialMediaSettings: SocialMediaSettings
    usePromoCodes: boolean;
    /** Логотип публичной витрины — BE отдаёт, когда настройки загружаются на showcase-домене. */
    showcaseLogo?: Picture | null;
}

